import { combineReducers } from "redux";
import {
  UPDATE_APPROACH_REQUEST,
  CREATE_APPROACH_REQUEST,
  CHANGE_APPROACH_WEIGHT_REQUEST,
  FETCH_APPROACHE_BY_ID_REQUEST,
  // DELETE_APPROACH_REQUEST,
  FETCH_APPROACHES_REQUEST,
} from "./constants";
// import { CREATE_DOCTOR_APPROACH_REQUEST } from "../doctor/constants";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { Action } from "./types";
import { Action as DoctorAction } from "../doctor/types";
import { Approach } from "../types";

function items(state: Approach[] = [], action: Action): Approach[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_APPROACHES_REQUEST):
      return action.payload;

    case UPDATE_APPROACH_REQUEST:
    case CHANGE_APPROACH_WEIGHT_REQUEST:
      return state.map((approach) =>
        approach.id === action.data.approachId ? { ...approach, isFetching: true } : approach
      );

    case getSuccessActionType(UPDATE_APPROACH_REQUEST):
    case getSuccessActionType(CHANGE_APPROACH_WEIGHT_REQUEST):
      return state.map((approach) =>
        approach.id === action.data.approachId ? { ...action.payload, isFetching: false } : approach
      );

    case getFailureActionType(UPDATE_APPROACH_REQUEST):
    case getFailureActionType(CHANGE_APPROACH_WEIGHT_REQUEST):
      return state.map((approach) =>
        approach.id === action.data.approachId ? { ...approach, isFetching: false } : approach
      );

    case getSuccessActionType(CREATE_APPROACH_REQUEST):
      return [...state, action.payload];
    default:
      return state;
  }
}

function approachById(state: Partial<Approach> = {}, action: Action): Partial<Approach> {
  switch (action.type) {
    case getSuccessActionType(FETCH_APPROACHE_BY_ID_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state = false, action: Action | DoctorAction) {
  switch (action.type) {
    case FETCH_APPROACHES_REQUEST:
      return true;
    case getSuccessActionType(FETCH_APPROACHES_REQUEST):
    case getFailureActionType(FETCH_APPROACHES_REQUEST):
      return false;

    case CREATE_APPROACH_REQUEST:
      return true;
    case getSuccessActionType(CREATE_APPROACH_REQUEST):
    case getFailureActionType(CREATE_APPROACH_REQUEST):
      return false;

    // case CREATE_DOCTOR_APPROACH_REQUEST:
    //   return true;
    // case getSuccessActionType(CREATE_DOCTOR_APPROACH_REQUEST):
    // case getFailureActionType(CREATE_DOCTOR_APPROACH_REQUEST):
    //   return false;
    default:
      return state;
  }
}

export const approaches = combineReducers({ items, approachById, isFetching });
